/**
 * Hasura dotazy. Pojmenování shoduje s tracked tabulkami a `v_invoices_latest`
 * view, které je třeba v Hasuře povolit (Track + příp. permissions).
 */
export const COMPANIES_QUERY = /* GraphQL */ `
  query Companies {
    companies(where: { is_active: { _eq: true } }, order_by: { display_order: asc }) {
      id
      slug
      name
      display_order
    }
  }
`;

export const EMAIL_ACCOUNTS_QUERY = /* GraphQL */ `
  query EmailAccounts {
    email_accounts(
      where: { is_active: { _eq: true } }
      order_by: { display_name: asc }
    ) {
      id
      display_name
      protocol
      folders_to_scan
      default_company_id
    }
  }
`;

export const INVOICES_QUERY = /* GraphQL */ `
  query Invoices(
    $companyId: uuid!
    $from: date
    $to: date
    $limit: Int!
    $offset: Int!
    $orderBy: [v_invoices_latest_order_by!]
    $includeMissingSupplier: Boolean!
    $supplierIlike: String
    $documentTypes: [document_type!]!
  ) {
    v_invoices_latest_aggregate(
      where: {
        company_id: { _eq: $companyId }
        archived: { _eq: false }
        status: { _in: [extracted, needs_review] }
        document_type: { _in: $documentTypes }
        display_date: { _gte: $from, _lte: $to }
        _or: [{ supplier_name: { _ilike: $supplierIlike } }, { supplier_name: { _is_null: $includeMissingSupplier } }]
      }
    ) {
      aggregate {
        count
        sum {
          total_amount
        }
      }
    }
    v_invoices_latest(
      where: {
        company_id: { _eq: $companyId }
        archived: { _eq: false }
        status: { _in: [extracted, needs_review] }
        document_type: { _in: $documentTypes }
        display_date: { _gte: $from, _lte: $to }
        _or: [{ supplier_name: { _ilike: $supplierIlike } }, { supplier_name: { _is_null: $includeMissingSupplier } }]
      }
      order_by: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      original_filename
      s3_key
      status
      document_type
      classification_uncertain
      issue_date
      due_date
      supplier_name
      supplier_id
      total_amount
      currency
      variable_symbol
      invoice_number
      confidence
      manually_corrected
      created_at
    }
  }
`;
